const SamsungTvKey = {
  N1: 101,
  N2: 98,
  N3: 6,
  N4: 8,
  N5: 9,
  N6: 10,
  N7: 12,
  N8: 13,
  N9: 14,
  N0: 17,
  PRECH: 259,
  VOL_UP: 7,
  VOL_DOWN: 11,
  MUTE: 27,
  CH_UP: 68,
  CH_DOWN: 65,
  TOOLS: 75,
  ENTER: 29443,
  RETURN: 88,
  INFO: 31,
  EXIT: 45,
  UP: 29460,
  DOWN: 29461,
  LEFT: 4,
  RIGHT: 5,
  RED: 108,
  GREEN: 20,
  YELLOW: 21,
  BLUE: 22,
  RW: 69,
  PAUSE: 74,
  FF: 72,
  REC: 192,
  PLAY: 71,
  STOP: 70,
};

export default SamsungTvKey;
